import { useEffect, useState } from "react";
import { Get_One_Webinar } from "../api/Get_One_Webinar";
import { TableContainer, Paper, Button } from "@mui/material";
import { Link } from "react-router-dom";

// material-ui
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import { StaffuseAuth } from "../../../security/StaffuseAuth";

function ViewWebinar() {
  const { logout } = StaffuseAuth();

  let array = ["first_name", "last_name", "country"];

  const [Webinar, setWebinar] = useState({});
  useEffect(() => {
    Get_One_Webinar("85067506377", setWebinar, logout);
  }, []);
  console.log("Webinar", Webinar);

  return (
    <div
      style={{
        backgroundColor: "#e5e5e5",
        minHeight: "93vh",
        paddingLeft: "10px",
        paddingTop: "10px",
      }}
    >
      <section>
        <h1 style={{ marginTop: "0px" }}>Invoices</h1>
        <h2>View Webinar</h2>
        <section>
          <TableContainer
            component={Paper}
            sx={{
              width: "100%",
              margin: "0 auto",
              overflow: "auto",
            }}
          >
            <Table
              aria-label="simple table"
              sx={{
                border: "1px solid #e0e0e0",
                tableLayout: "fixed",
              }}
            >
              <TableHead>
                <TableRow>
                  {array.map((item, index) => (
                    <TableCell
                      className="tableCellHeader" // Add this line to include the CSS class
                      align="left"
                      style={{
                        position: "sticky",
                        Top: 0,
                        zIndex: 1,
                        fontWeight: "bold", // Make Text bold
                        padding: "8px", // Adjust padding as needed To make cells smaller
                      }}
                    >
                      {item}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {Webinar &&
                Webinar.registrants &&
                Array.isArray(Webinar.registrants) ? (
                  Webinar.registrants.map((Registrant, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:hover": {
                          backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                          "& .MuiTableCell-root": {
                            padding: "8px",
                            wordWrap: "break-word",
                            overflowWrap: "break-word", // Adjust padding here to make cells smaller
                          },
                        },
                      }}
                    >
                      {array.map((element, index) => (
                        <TableCell
                          component="th"
                          scope="row"
                          sx={{
                            padding: "8px",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                          }}
                        >
                          {Registrant[element]}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : (
                  <></>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </section>
        <div style={{ marginTop: "20px" }}></div>
      </section>
    </div>
  );
}

export default ViewWebinar;
